// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3eu6m","content":"LayoutSettings_content__2naBe"};